<script lang="ts">
  import Router, { push } from "svelte-spa-router";
  import { routes } from "../routes";

  import Navbar from "../organisms/Navbar.svelte";
  import Sidebar from "../organisms/Sidebar.svelte";
  import Footer from "../organisms/Footer.svelte";
  import { ApiService } from "../services/api.service";
  import { onMount } from "svelte";

  const client = ApiService.createClient();

  onMount(async () => {
    try {
      const { data } = await client.get("/auth/validate");
      console.log(data);
    } catch (e) {
      push("/login");
    }
  });
</script>

<Navbar />
<div class="flex">
  <Sidebar />
  <div class="flex flex-col flex-1 with--sidemenu">
    <div class="main main--p">
      <Router {routes} />
    </div>
    <Footer />
  </div>
</div>
